import script from "./Home.vue?vue&type=script&setup=true&lang=js"
export * from "./Home.vue?vue&type=script&setup=true&lang=js"

import "./Home.vue?vue&type=style&index=0&id=1835aa4d&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2842137582/src/pineridgefarmsapartments/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1835aa4d"]])

export default __exports__